import React from 'react';
import { Link } from 'react-router-dom';
import './style.css';

const ImageOrText = props => {
  return (
    <div className="logo-box">
      <strong className="image-spacer">{props.name}</strong>
      <br />
      <Link to={props.to}>
        <img
          src={props.image}
          alt={props.name}
          className="image-spacer object"
        />
      </Link>
    </div>
  );
};

export default ImageOrText;



// WEBPACK FOOTER //
// ./src/preference/components/Pair/imageortext.js